import { RolesService } from './roles.service'
import {
  FetchRolesRequest,
  FetchRolesSuccess,
  FetchRolesFailure,
  FetchRoleRequest,
  FetchRoleSuccess,
  FetchRoleFailure,
  DeleteRoleRequest,
  DeleteRoleSuccess,
  DeleteRoleFailure,
  CreateRoleRequest,
  CreateRoleSuccess,
  CreateRoleFailure,
  UpdateRoleRequest,
  UpdateRoleSuccess,
  UpdateRoleFailure,
  FetchPermissionsSuccess,
  FetchPermissionsRequest,
  FetchPermissionsFailure,
} from './roles.actions'
import { ShowSnackbar } from '../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as Roles from './roles.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class RolesEffects {
  constructor(
    private actions: Actions,
    private rolesService: RolesService,
    private router: Router,
  ) {}

  FetchRoles$ = createEffect(() =>
    this.actions.pipe(
      ofType(Roles.FETCH_ROLES_REQUEST),
      switchMap((action: FetchRolesRequest) => {
        return this.rolesService.fetchRoles(action.payload).pipe(
          map((result) => {
            return new FetchRolesSuccess(
              result.data.results,
              result.data.totalCount,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            return of(new FetchRolesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchPermissions$ = createEffect(() =>
    this.actions.pipe(
      ofType(Roles.FETCH_PERMISSIONS_REQUEST),
      switchMap((action: FetchPermissionsRequest) => {
        return this.rolesService.fetchPermissions(action.payload).pipe(
          map((result) => {
            return new FetchPermissionsSuccess(result.data.permissions)
          }),
          catchError((err, caught) => {
            return of(new FetchPermissionsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchRole$ = createEffect(() =>
    this.actions.pipe(
      ofType(Roles.FETCH_ROLE_REQUEST),
      switchMap((action: FetchRoleRequest) => {
        return this.rolesService.fetchRole(action.id).pipe(
          map((result) => {
            return new FetchRoleSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchRoleFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteRole$ = createEffect(() =>
    this.actions.pipe(
      ofType(Roles.DELETE_ROLE_REQUEST),
      switchMap((action: DeleteRoleRequest) => {
        return this.rolesService.deleteRole(action.id).pipe(
          switchMap(() => {
            return [new DeleteRoleSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteRoleFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateRole$ = createEffect(() =>
    this.actions.pipe(
      ofType(Roles.CREATE_ROLE_REQUEST),
      switchMap((action: CreateRoleRequest) => {
        return this.rolesService.createRole(action.payload).pipe(
          switchMap(() => {
            this.router.navigate(['/admin/roles'])
            return [new CreateRoleSuccess()]
          }),
          catchError(() => {
            return of(new CreateRoleFailure({}))
          }),
        )
      }),
    ),
  )

  UpdateRole$ = createEffect(() =>
    this.actions.pipe(
      ofType(Roles.UPDATE_ROLE_REQUEST),
      switchMap((action: UpdateRoleRequest) => {
        return this.rolesService.updateRole(action.id, action.payload).pipe(
          switchMap(() => {
            this.router.navigate(['/admin/roles'])
            return [new UpdateRoleSuccess()]
          }),
          catchError(() => {
            return of(new UpdateRoleFailure({}))
          }),
        )
      }),
    ),
  )
}
